import _ from 'underscore';

eventHelpersService.$inject = [];

export default function eventHelpersService() {
  class EventHelpersService {
    isWidgetVisible(event) { //eslint-disable-line
      const widget = _.get(event, 'config.enableTablelist');

      return _.isUndefined(widget) ? true : widget;
    }

    isGuestlistVisible(event) { //eslint-disable-line
      const guestlist = _.get(event, 'config.disableGuestList');

      return _.isUndefined(guestlist) ? false : !guestlist;
    }

    isReservationRequestVisible(event) { //eslint-disable-line
      const request = _.get(event, 'config.disableReservation');

      return _.isUndefined(request) ? false : !request;
    }

    isExternalTicketLinkVisible(event) { //eslint-disable-line
      const external = _.get(event, 'config.externalTicketLink');

      return _.isUndefined(external) ? false : external;
    }
  }

  return new EventHelpersService();
}



// WEBPACK FOOTER //
// ./src/services/eventHelpersService.js